var map = {
	"./House": 34,
	"./House.js": 34,
	"./Label": 17,
	"./Label.js": 17,
	"./LeftWall": 19,
	"./LeftWall.js": 19,
	"./Popup": 21,
	"./Popup.js": 21,
	"./RightWall": 20,
	"./RightWall.js": 20,
	"./Tile": 18,
	"./Tile.js": 18,
	"./TopWall": 16,
	"./TopWall.js": 16,
	"./Wall": 9,
	"./Wall.js": 9,
	"./WindowCanvas": 5,
	"./WindowCanvas.js": 5
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;